<template>
  <div class="mm-page-main">
    <div class="pagemain">
      <div class="form-group">

        <div class="form-group-content">

          <div class="mm-row">
            <div class="mm-col">
              <div class="mm-item mb20">
                <label class="mm-label">會員類別：</label>
                <el-radio-group :disabled="true" v-model="showdata.type">
                  <el-radio-button label="0">個人</el-radio-button>
                  <el-radio-button label="1">企業</el-radio-button>
                  <el-radio-button label="2">行家</el-radio-button>
                </el-radio-group>
              </div>
            </div>
          </div>
          <person v-if="showdata.type==0" :showdata="showdata"></person>
          <company v-if="showdata.type==1" :showdata="showdata"></company>
          <connoisseur v-if="showdata.type==2" :showdata="showdata"></connoisseur>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import person from "./PersonEdit.vue";
import company from "./CompanyEdit.vue";
import connoisseur from "./ConnoisseurEdit.vue";
export default {
  props: ['customer_id'],
  components: {
    person,
    company,
    connoisseur
  },
  data () {
    return {
      showdata: {},
      type: 0,
      clientpage: 'person',
    };
  },
  methods: {
    pageback () {
      this.$router.go(-1);
    },
    getdata () {
      this.post('/api/customer/customerinfo', {
        customer_id: this.customer_id
      }).then(response => {
        let data = response[0];
        let customer_files_list = [];
        let review_files_list = [];

        data.files.map((v) => {
          if (v.type == 1) {
            // let file = {
            //   fileurl:v.fileurl,
            //   url: v.fileurl
            // }
            // customer_files_list.push(file);
            let temp = {};
            temp.fileurl = v.fileurl;
            temp.url = this.apiurl + v.fileurl;
            temp.id = v.id;
            temp.files_type = v.files_type;
            temp.files_type_id = v.files_type_id;
            customer_files_list.push(temp);
          } else if (v.type == 2) {
            let file = {
              fileurl: v.fileurl,
              url: this.apiurl+v.fileurl
            }
            review_files_list.push(file);
          }
        })

        data.customer_files_list = customer_files_list;
        data.review_files_list = review_files_list;
        this.showdata = data;
      }).catch(error => {
        console.log(error);
      });
    }
  },
  created () {
    this.getdata();
  }

};
</script>
<style scoped>
</style>
